import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from 'src/content/Settings/Billings/styles';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';
import { Overlay } from './styles';
import { useEffect, useRef } from 'react';
import { BILLING_ROUTE } from 'src/utils/constants';
import useSubscriptionPlan from 'src/hooks/useSubscriptionPlan';

interface SubscriptionExpiredModalProps {
  open: boolean;
}

const SubscriptionExpiredModal = ({ open }: SubscriptionExpiredModalProps) => {
  const subscriptionElementRef = useRef<HTMLDivElement | null>(null);
  const { isTrialPlan } = useSubscriptionPlan();
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!open) return null;

  useEffect(() => {
    if (
      !subscriptionElementRef.current ||
      !subscriptionElementRef.current.parentNode
    )
      return;

    const target = subscriptionElementRef.current;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const removedNode of mutation.removedNodes) {
          if (removedNode === target) {
            setTimeout(() => {
              if (!document.body.contains(target)) {
                window.location.reload();
              }
            }, 100);
          }
        }
      }
    });

    observer.observe(target.parentNode, {
      childList: true
    });

    return () => observer.disconnect();
  }, []);
  return (
    <Overlay>
      <Paper
        elevation={3}
        sx={{
          p: 3,
          border: '1px solid #D6D6D6',
          borderRadius: 2,
          maxWidth: 500,
          textAlign: 'center'
        }}
        ref={subscriptionElementRef}
      >
        <Typography variant="h6" gutterBottom>
          {isTrialPlan ? t(T.trialExpiredTitle) : t(T.subscriptionExpiredTitle)}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {t(T.subscriptionExpiredDesc)}
        </Typography>
        <PrimaryButton
          variant="contained"
          onClick={() => navigate(BILLING_ROUTE)}
        >
          {t(T.upgradeNow)}
        </PrimaryButton>
      </Paper>
    </Overlay>
  );
};

export default SubscriptionExpiredModal;
